import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';

@Component({
    selector: 'app-shop',
    templateUrl: './shop.component.html',
    styles: [],
    standalone: true,
    imports: [RouterLink, CommonModule, CarouselComponent]
})
export class ShopComponent implements OnInit {
  products: any[] = [{
    foto: 'assets/Images/product.jpeg',
    description: 'Laptop HP Elite i7 11800H',
    price: 'RD$ 59,400',
    comment: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatibus rerum, animi aspernatur repellendus aperiam quos eos quisquam cupiditate officiis non maiores dignissimos ipsam error ducimus ex adipisci, perspiciatis eum voluptas.',
    off: '',
  },
  {
    foto: 'assets/Images/product-2.jpeg',
    description: 'Laptop HP Elite i7 11800H',
    price: 'RD$ 59,400',
    comment: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatibus rerum, animi aspernatur repellendus aperiam quos eos quisquam cupiditate officiis non maiores dignissimos ipsam error ducimus ex adipisci, perspiciatis eum voluptas.',
    off: '10%',
  },
  {
    foto: 'assets/Images/product-3.jpeg',
    description: 'Laptop HP Elite i7 11800H',
    price: 'RD$ 59,400',
    comment: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatibus rerum, animi aspernatur repellendus aperiam quos eos quisquam cupiditate officiis non maiores dignissimos ipsam error ducimus ex adipisci, perspiciatis eum voluptas.',
    off: '5%',
  },
  {
    foto: 'assets/Images/product.jpeg',
    description: 'Laptop HP Elite i7 11800H',
    price: 'RD$ 59,400',
    comment: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatibus rerum, animi aspernatur repellendus aperiam quos eos quisquam cupiditate officiis non maiores dignissimos ipsam error ducimus ex adipisci, perspiciatis eum voluptas.',
    off: '',
  },
  {
    foto: 'assets/Images/product-2.jpeg',
    description: 'Laptop HP Elite i7 11800H',
    price: 'RD$ 59,400',
    comment: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatibus rerum, animi aspernatur repellendus aperiam quos eos quisquam cupiditate officiis non maiores dignissimos ipsam error ducimus ex adipisci, perspiciatis eum voluptas.',
    off: '',
  },
  {
    foto: 'assets/Images/product-3.jpeg',
    description: 'Laptop HP Elite i7 11800H',
    price: 'RD$ 59,400',
    comment: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatibus rerum, animi aspernatur repellendus aperiam quos eos quisquam cupiditate officiis non maiores dignissimos ipsam error ducimus ex adipisci, perspiciatis eum voluptas.',
    off: '5%',
  },
  {
    foto: 'assets/Images/product.jpeg',
    description: 'Laptop HP Elite i7 11800H',
    price: 'RD$ 59,400',
    comment: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatibus rerum, animi aspernatur repellendus aperiam quos eos quisquam cupiditate officiis non maiores dignissimos ipsam error ducimus ex adipisci, perspiciatis eum voluptas.',
    off: '5%',
  },
  {
    foto: 'assets/Images/product-3.jpeg',
    description: 'Laptop HP Elite i7 11800H',
    price: 'RD$ 59,400',
    comment: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatibus rerum, animi aspernatur repellendus aperiam quos eos quisquam cupiditate officiis non maiores dignissimos ipsam error ducimus ex adipisci, perspiciatis eum voluptas.',
    off: '5%',
  },
  {
    foto: 'assets/Images/product-2.jpeg',
    description: 'Laptop HP Elite i7 11800H',
    price: 'RD$ 59,400',
    comment: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatibus rerum, animi aspernatur repellendus aperiam quos eos quisquam cupiditate officiis non maiores dignissimos ipsam error ducimus ex adipisci, perspiciatis eum voluptas.',
    off: '5%',
  },
  {
    foto: 'assets/Images/product-3.jpeg',
    description: 'Laptop HP Elite i7 11800H',
    price: 'RD$ 59,400',
    comment: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatibus rerum, animi aspernatur repellendus aperiam quos eos quisquam cupiditate officiis non maiores dignissimos ipsam error ducimus ex adipisci, perspiciatis eum voluptas.',
    off: '10%',
  },
  {
    foto: 'assets/Images/product.jpeg',
    description: 'Laptop HP Elite i7 11800H',
    price: 'RD$ 59,400',
    comment: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatibus rerum, animi aspernatur repellendus aperiam quos eos quisquam cupiditate officiis non maiores dignissimos ipsam error ducimus ex adipisci, perspiciatis eum voluptas.',
    off: '',
  },
  {
    foto: 'assets/Images/product.jpeg',
    description: 'Laptop HP Elite i7 11800H',
    price: 'RD$ 59,400',
    comment: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatibus rerum, animi aspernatur repellendus aperiam quos eos quisquam cupiditate officiis non maiores dignissimos ipsam error ducimus ex adipisci, perspiciatis eum voluptas.',
    off: '',
  },];

  constructor() { }

  ngOnInit(): void {
  }

}
